import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { CustomersService } from 'src/app/services/customer.service';

@Component({
  selector: 'kt-visit-and-task-metrics',
  templateUrl: './visit-and-task-metrics.component.html',
  styleUrls: ['./visit-and-task-metrics.component.css']
})
export class VisitAndTaskMetricsComponent implements OnInit {

  @Input() customerId: number;
  @Input() isFinancialYear:boolean=false;
  @Output() dataLoaded = new EventEmitter<void>(); // Event emitter for data load

  visitAndTaskMetrics: any;
  taskStatusData:any;
  taskStatusDataObj: any ={ labels: [], data: [], total: '', reportLabel: '', options: {} };
  LeadDynamicFormsCount: any;
  LeadVisitFormsCount: any;
  visitAndDynamicFormData: any={ labels: [], data: [], total: '', reportLabel: '', options: {} };
  loading:boolean=true;
  private loadingSubject = new BehaviorSubject<boolean>(true);
  loading$ = this.loadingSubject.asObservable().pipe(shareReplay(1));
  LeadTaskCountModel: any=[];
  overdueTaskLabels:any=[];
  overdueTaskData:any=[];
  archivedTaskData: any[]=[];
  archivedTaskLabels: string[]=[];
  overdueColor: string[]=[];
  archivedColor: string[]=[];

  constructor(
    private customerService : CustomersService,
    private cdr: ChangeDetectorRef,

  ) { }

  ngOnInit(): void {
    if (this.customerId && this.customerId > 0) {
      setTimeout(()=>{
        this.fetchVisitAndTaskMetrics()
      },1000)
    }
  }

  fetchVisitAndTaskMetrics(){
    this.loadingSubject.next(true);
    this.customerService.getVisitAndTaskMetrics(this.customerId,this.isFinancialYear).subscribe({
      next:(res:any)=>{
        this.visitAndTaskMetrics = res && res.data ? res.data : null;
        this.taskStatusData = (this.visitAndTaskMetrics && this.visitAndTaskMetrics.LeadTaskCountModel)? this.visitAndTaskMetrics.LeadTaskCountModel[0] : null;
        this.LeadDynamicFormsCount = this.visitAndTaskMetrics ? this.visitAndTaskMetrics.LeadDynamicFormsCount : null;
        this.LeadVisitFormsCount = this.visitAndTaskMetrics ? this.visitAndTaskMetrics.LeadVisitFormsCount : null;
        this.LeadTaskCountModel = (this.visitAndTaskMetrics && this.visitAndTaskMetrics.LeadTaskCountModel) ? this.visitAndTaskMetrics.LeadTaskCountModel[0] : {};
        this.transformTaskStatusData(this.taskStatusData);
        this.transformVisitDynamicForm()
        this.loadingSubject.next(false);
        this.dataLoaded.emit()
      },
      error:()=>{
        this.loadingSubject.next(false);
        this.dataLoaded.emit()
      }
    })
  }

  transformTaskStatusData(data:any){
    if(!data){
      return;
    }
    this.taskStatusDataObj.labels = ['Pending','Completed'];
    this.taskStatusDataObj.data=[{
      data:[
        data.PendingTasksCount,
        data.CompletedTasksCount,
      ],
      color:['#FBBC04','#34A853']
    }]

    if(data.OverduePendingTasksCount !== 0 || data.PendingTasksCount !== 0){
      this.overdueTaskData = [data.OverduePendingTasksCount,data.PendingTasksCount-data.OverduePendingTasksCount];
      this.overdueTaskLabels= [`Overdue(${this.overdueTaskData[0]})`,`On Time(${this.overdueTaskData[1]})`]
      this.overdueColor=['#EA4335','#FBBC04']
    }
    
    if(data.ArchivedTasksCount !== 0 || data.PendingTasksCount !==0){
      this.archivedTaskData = [data.ArchivedTasksCount,data.PendingTasksCount+data.CompletedTasksCount];
      this.archivedTaskLabels= [`Archived(${this.archivedTaskData[0]})`,`Current Task(${this.archivedTaskData[1]})`]
      this.archivedColor=['#D97F7F','#4285F4']
    }
    
  }

  transformVisitDynamicForm(){

    if(!this.LeadDynamicFormsCount){
      return;
    }
    let label : any[]=[];
    let dynamicData:any[]=[]
    let visitData:any[]=[]
    const allYears = new Set([
      ...(this.LeadDynamicFormsCount ? this.LeadDynamicFormsCount.map((res: any) => res.Year) : []),
      ...(this.LeadVisitFormsCount ? this.LeadVisitFormsCount.map((res: any) => res.Year) : [])
    ]);

    allYears.forEach((year: any) => {
      if (this.LeadDynamicFormsCount && !this.LeadDynamicFormsCount.some((obj: any) => obj.Year === year)) 
      {
        this.LeadDynamicFormsCount.push({ Year: year, DynamicFormsCount: 0 });
      }
    });
    allYears.forEach((year:any)=>{
      if(!this.LeadVisitFormsCount.some((obj:any)=>obj.Year === year)){
        this.LeadVisitFormsCount.push({Year:year,VisitFormsCount:0})
      }
    })


    this.LeadDynamicFormsCount.sort((a:any,b:any)=>parseInt(a.Year) - parseInt(b.Year));
    this.LeadVisitFormsCount.sort((a:any,b:any)=>parseInt(a.Year) - parseInt(b.Year));

    for(let obj of this.LeadDynamicFormsCount){
      label.push(obj.Year)
      dynamicData.push(obj.DynamicFormsCount)
    }
    for(let obj of this.LeadVisitFormsCount){
      visitData.push(obj.VisitFormsCount)
    }

    this.visitAndDynamicFormData.labels = label;
    this.visitAndDynamicFormData.data = [
      {
        data: dynamicData,
        label: 'Dynamic Form',
        color: '#0095ff',
        
        
      },
      {
        data:visitData,
        label: 'Visit Form',
        color: '#00e096',
        
      }
    ]
  }

}
